"use client"

import { useEffect, useState, memo } from "react"
import MainLayout from "@/layout/MainLayout"
import StandardCard from "@/components/cards/StandardCard"
import { LISTING_GRID_CLASS, renderNewsGridWithAds } from "@/components/ListingGridWithAds"
import PageHeader from "@/components/ui/PageHeader"
import Pagination from "@/components/ui/Pagination"
import axiosInstance from "@/lib/axios"
import { LISTING_NEWS_PER_PAGE } from "@/lib/advertisement/constants"
import { CardGridSkeleton, EmptyState } from "@/components/ui/Skeleton"

const RecommendedNews = ({ initialData = null }) => {
    const [news, setNews] = useState(() => initialData?.data || [])
    const [pagination, setPagination] = useState(() => initialData?.pagination || {})
    const [loading, setLoading] = useState(() => initialData == null)
    const [error, setError] = useState(null)
    const [currentPage, setCurrentPage] = useState(1)

    const fetchNivadakNews = async (page = 1) => {
        try {
            setLoading(true)
            setError(null)
            const response = await axiosInstance.get('/news/recommended', {
                params: { page, limit: LISTING_NEWS_PER_PAGE },
            })
            if (response.data.success) {
                setNews(response.data.data || [])
                setPagination(response.data.pagination || {})
            } else {
                setError(response.data.error || 'बातम्या लोड करण्यात अडचण आली.')
            }
        } catch (err) {
            console.error("Error fetching nivadak news:", err)
            setError('बातम्या लोड करण्यात अडचण आली.')
        } finally {
            setLoading(false)
            window.scrollTo({ top: 0, behavior: 'smooth' })
        }
    }

    useEffect(() => {
        if (!initialData) return
        if (initialData.page !== 1) return
        setNews(initialData.data || [])
        setPagination(initialData.pagination || {})
        setLoading(false)
        setCurrentPage(1)
    }, [initialData])

    useEffect(() => {
        if (currentPage === 1 && initialData?.page === 1) return
        fetchNivadakNews(currentPage)
        // eslint-disable-next-line react-hooks/exhaustive-deps -- page-driven fetch
    }, [currentPage, initialData?.page])

    return (
        <MainLayout>
            <PageHeader
                title="निवडक बातम्या"
                description="संपूर्ण महाराष्ट्रातील निवडक बातम्या."
                accentName="Maharashtra"
            />

            {loading && !news.length ? (
                <CardGridSkeleton count={9} />
            ) : error ? (
                <EmptyState message={error} />
            ) : news.length > 0 ? (
                <>
                    <div className={LISTING_GRID_CLASS}>
                        {renderNewsGridWithAds(news, 'recommended', (item) => (
                            <StandardCard
                                key={item.id}
                                layout="col"
                                headline={item.title}
                                imageUrl={item.featuredImage}
                                data={item}
                            />
                        ))}
                    </div>

                    {pagination.totalPages > 1 && (
                        <div className="mt-12">
                            <Pagination
                                currentPage={pagination.currentPage}
                                totalPages={pagination.totalPages}
                                onPageChange={setCurrentPage}
                            />
                        </div>
                    )}
                </>
            ) : (
                <EmptyState message="सध्या निवडक बातम्या उपलब्ध नाहीत." />
            )}
        </MainLayout>
    )
}

export default memo(RecommendedNews)
